import { createAsyncThunk } from '@reduxjs/toolkit';
import { getConnectwiseSites } from 'services/connectwise';

interface IProps {
  psaId: number;
  companyId: number;
}

export const ThunkGetConnectwiseSites = createAsyncThunk(
  'connectwise/getConnectwiseSites',
  ({ psaId, companyId }: IProps) => getConnectwiseSites(psaId, companyId).then(res => res.data),
);
